import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import CrediDebitNoteBasicInfoComponent from './credit-debit-note-basic-info.component';

export const CrediDebitNoteComponent = ({
    selectCrediDebitNotes, handleInnerFormChange, referenceTypeList, documentTypeList, grnsList, stockTransfersList, ordersList,
    supplierNameList, storeNameList, back, handleFormSubmit
}: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Credi/Debit Note Basic Information',
            component: <CrediDebitNoteBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectCrediDebitNotes={selectCrediDebitNotes}
                referenceTypeList={referenceTypeList}
                documentTypeList={documentTypeList}
                grnsList={grnsList}
                stockTransfersList={stockTransfersList}
                ordersList={ordersList}
                supplierNameList={supplierNameList}
                storeNameList={storeNameList}
            />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default CrediDebitNoteComponent;
